import { axiosInstance, authHeader, handleResponse, handleError } from '../helpers';
import { api } from '../constants'

export const activityService = {
    fetchActivitiesList,
    createActivity,
    updateActivity,
    deleteActivity
};

function fetchActivitiesList() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return axiosInstance.get(api.activities.fetchActivities, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function createActivity(activityDetails) {

    const requestOptions = {
        method: 'POST',
        headers: authHeader()
    };

    return axiosInstance.post(api.activities.createActivity, activityDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function updateActivity(activityDetails) {
    const requestOptions = {
        method: 'put',
        headers: authHeader()
    };

    return axiosInstance.put(api.activities.updateActivity, activityDetails, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}

function deleteActivity(activityId) {
    const requestOptions = {
        method: 'DELETE',
        headers: authHeader()
    };

    return axiosInstance.delete(`${api.activities.deleteActivity}/${activityId}`, requestOptions)
        .then(handleResponse)
        .then(data => {
            return data;
        })
        .catch(error => handleError(error.response));
}